import { TwitterAvatar } from "./Avatar";
import { styled } from "@stitches/react";

export const Profile = styled("a", {
  display: "flex",
  paddingTop: "1rem",
  paddingLeft: "1rem",
  marginLeft: "-1rem",
  marginBottom: "1.5rem",
  fontSize: "1.3rem",
  minHeight: 110,
  textDecoration: "none",
  color: "#000",
  letterSpacing: "0.01rem",
  borderRadius: 8,

  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.05)",
  },
});

export function Item({ data }) {
  return (
    <Profile
      href={`https://twitter.com/${data.screen_name}`}
      target="_blank"
      rel="noreferrer"
      key={data.id}
    >
      <TwitterAvatar picture={data.profile_image_url} name={data.name} />
      <div>
        <strong>
          {data.name}{" "}
          <span style={{ fontSize: "0.95rem", fontWeight: "normal" }}>
            @{data.screen_name}
          </span>
        </strong>
        <p style={{ marginTop: 3 }}>{data.description}</p>
      </div>
    </Profile>
  );
}
